import AdsAutoinvestGmvPage from "@faire/prototype-playground/workspace/kli/ads-autoinvest-gmv";
import { Route, Switch } from "react-router-dom";

export function KevinLiRoutes() {
  return (
    <Switch>
      <Route path="/kli/ads-autoinvest-gmv" component={AdsAutoinvestGmvPage} />
    </Switch>
  );
}

export const slug = "kli";
